import { Resource } from "src/app/global/domain/resource.model";
import { Transferencia } from "./transferencia.model";

export class ArquivoComprovantePix extends Resource {
    id: number;
    fileName: string;
    filePath: string;
    transferencia: Transferencia;
    dataCriacao: Date;
}